import { fromQueryString, toQueryString } from '@suntex.core/utils'

function enumValues<TEnum>(enumType: TEnum): TEnum[] {
  return Object.values(enumType as any).filter(
    (value) => typeof value === 'number'
  ) as TEnum[]
}

//TODO: should move these to FimUtils for the game code
export function initializeGameHost() {
  window.toQueryString = toQueryString
  window.fromQueryString = fromQueryString
  window.enumValues = enumValues
}
